module.exports = __webpack_public_path__ + "img/law_bgg.d204cf7b.jpeg";